import _ from "lodash";
import { CountryCodes } from "utils/country-codes";

export const CountryCodeMap = _.keyBy(CountryCodes, "code");
